// Deterministic prerender for the dynamic team route.
// See `src/utils/getPrerenderEntries/index.js` and issue #63 for the
// "why". SvelteKit calls `entries()` during prerendering and guarantees
// every returned param is built, replacing the non-deterministic crawler
// traversal that was leaving some `/teams/<slug>/` pages out of `dist/`
// on alternate builds.

import { getTeamSlugs } from '$utils/getPrerenderEntries';

export const prerender = true;

export async function entries() {
  return (await getTeamSlugs()).map((slug) => ({ slug }));
}
